module.exports = {
      id: "header_logo-usage",
      viewBox: "0 0 78 68",
      url: __webpack_public_path__ + "svg-sprite-71cc17c6d762c8495e8a5375f2902e76.svg#header_logo",
      toString: function () {
        return this.url;
      }
    }